import { currentLang, pick } from "@kit/lang";

const STRINGS = {
  title: { tr: "Akış", en: "Flow" },
  topTitle: { tr: "Akış · {n}", en: "Flow · {n}" },
  left: { tr: "Kalan", en: "Left" },
  loading: { tr: "Yükleniyor…", en: "Loading…" },
  hint1: { tr: "Renk eşleşmesini bul · atıcı sırasını planla", en: "Match the colors · plan the shooter order" },
  tray: { tr: "TEPSİ", en: "TRAY" },
  guess: { tr: "Tahmin et", en: "Guess" },
  skipTop: { tr: "Atla ›", en: "Skip ›" },
  stuck: { tr: "Çıkış yok: resmi tahmin et!", en: "No way out: guess the picture!" },
  trayFull: { tr: "Tepsi dolu!", en: "Tray full!" },
  question: { tr: "Bu ne? · resim %{pct} açık", en: "What is it? · picture {pct}% open" },
  guessHint: { tr: "Yanlış tahmin bir tepsi gözünü kilitler.", en: "A wrong guess locks a tray slot." },
  correct: { tr: "Doğru! Resmi %{pct} açıkken bildin.", en: "Correct! You named it at {pct}% open." },
  repeat: { tr: "Bunu zaten denedin.", en: "You already tried that." },
  wrongFull: { tr: "Yanlış · tepsi tamamen kilitlendi.", en: "Wrong · the tray is fully locked." },
  wrongLock: { tr: "Yanlış · bir tepsi gözü kilitlendi (bir atıcı bitince açılır).", en: "Wrong · a tray slot is locked (it opens when a shooter empties)." },
  shareGuess: { tr: "Akış'ta resmi %{pct} açıkken bildim!", en: "I named the picture in Flow at {pct}% open!" },
  shareClear: { tr: "Akış'ta {n}. seviyeyi temizledim!", en: "I cleared Flow level {n}!" },
  wonGuess: { tr: "Erken bildin!", en: "Early guess!" },
  wonGuessSub: { tr: "Resmi %{pct} açıkken bildin", en: "You named it at {pct}% open" },
  wonClear: { tr: "Temizlendi!", en: "Cleared!" },
  wonClearSub: { tr: "Tahtayı temizledin", en: "Board cleared" },
  picture: { tr: " · Resim: {name}", en: " · Picture: {name}" },
  score: { tr: " · Skor {score}", en: " · Score {score}" },
  share: { tr: "Paylaş", en: "Share" },
  lost: { tr: "Tepsi doldu", en: "Tray full" },
  lostSkip: { tr: "{left} blok kaldı. {fails} denemedir takıldın, istersen ücretsiz atla.", en: "{left} blocks left. Stuck for {fails} tries: skip for free if you like." },
  lostRetry: { tr: "{left} blok kaldı. Hemen tekrar dene.", en: "{left} blocks left. Try again right away." },
  retry: { tr: "Tekrar", en: "Retry" },
  skip: { tr: "Atla", en: "Skip" },
  instructions: {
    tr: "Renkli atıcıları konveyöre sür, tahtayı boşalt; altındaki gizli resmi ya temizleyerek ya da bilerek aç.",
    en: "Send the colored shooters onto the conveyor and clear the board; reveal the hidden picture by clearing it or by guessing it.",
  },
} as const;

export type Key = keyof typeof STRINGS;
export function t(key: Key, vars: Record<string, string | number> = {}): string {
  return pick(currentLang(), STRINGS[key]).replace(/\{(\w+)\}/g, (_m, k: string) => String(vars[k] ?? ""));
}
